import { ChatFileUploadHeadersDto, FileRecord } from '@matap/shared';
import { EventEmitter } from '@/webrtc/utils/event.emitter';

// Unified interface to track the promise, the queue job, and the network abort trigger
export interface IOTask<T> {
  promise: Promise<T>;
  job?: any;
  cancel: () => void;
}

export abstract class FileStorage extends EventEmitter<
  'downloaded' | 'downloading' | 'uploaded' | 'uploading' | 'moved' | 'evicted' | 'upload-error' | 'download-error'
> {
  protected dlProgress = new Map<string, number>();
  protected upProgress = new Map<string, number>();

  protected activeDownloads = new Map<string, IOTask<string>>();
  protected activeUploads = new Map<string, IOTask<FileRecord>>();

  constructor(public readonly name: string) {
    super();
  }

  public abstract initialize(): Promise<void>;
  public abstract getByUrl(url: string): Promise<string | undefined> | string | undefined;
  public abstract download(url: string): Promise<string>;
  public abstract upload(localAddress: string, url: string, mime: string, fileName: string, headers?: ChatFileUploadHeadersDto): Promise<FileRecord>;
  public abstract mapToUrl(localAddress: string, url: string): Promise<void>;
  public abstract generateKey(remoteUrl: string): string;
  public abstract released(localAddress: string, reason: string): void;
  public abstract purge(): Promise<void>;

  protected setDownloadProgress(url: string, progress: number, localAddress?: string, error?: any) {
    if (localAddress || error) {
      this.dlProgress.delete(url);
    } else {
      this.dlProgress.set(url, progress);
    }
    if (localAddress) {
      this.emit('downloaded', url, localAddress);
    } else if (error) {
      this.emit('download-error', url, error);
    } else {
      this.emit('downloading', url, progress);
    }
  }

  public setUploadProgress(localAddress: string, progress: number, fileRecord?: FileRecord, error?: any) {
    if (fileRecord || error) {
      this.upProgress.delete(localAddress);
    } else {
      this.upProgress.set(localAddress, progress);
    }
    if (fileRecord) {
      this.emit('uploaded', localAddress, fileRecord);
    } else if (error) {
      this.emit('upload-error', localAddress, error);
    } else {
      this.emit('uploading', localAddress, progress);
    }
  }

  public downloadProgress(url: string) {
    return this.dlProgress.get(url) ?? -1;
  }
  public uploadProgress(localAddress: string) {
    return this.upProgress.get(localAddress) ?? -1;
  }

  protected printDiagnosticsReport(triggerReason: string) {
    /*let listenersCount = 0;
    this.listeners('moved')?.forEach((listeners) => (listenersCount += listeners.length));

    const activeDlJobs = this.activeDownloads.size;
    const activeUpJobs = this.activeUploads.size;

    // Calculate the size of the progress maps
    const dlProgressCount = this.dlProgress.size;
    const upProgressCount = this.upProgress.size;

    console.log(`\n=== 📊 FILE-SYSTEM: [${this.name}] ===`);
    console.log(`Trigger: ${triggerReason}`);

    const diagnosticsTable = [
      { Operation: 'Downloads', Count: activeDlJobs, progressCount: dlProgressCount },
      { Operation: 'Uploads', Count: activeUpJobs, progressCount: upProgressCount },
      { Operation: 'Listeners', Count: listenersCount },
    ];

    console.table(diagnosticsTable);
    console.log(`======\n`);*/
  }
}
